/* mlb-multicolor
   Lets a visitor add several colors of one style to their store request in a
   single click, instead of picking a swatch and adding, again and again.

   It sits inside the "Your store request" panel on the bulk order page:
     - a row of color chips, each a checkbox
     - Select all / Clear
     - the Add button says how many it will add

   It stands on top of mlb-order.js and does not edit it. The product config
   (colors, handle, spots, method) is read from the same JSON the page already
   prints, and the list is written to the same localStorage key the tray reads
   (mlbStoreRequest), then announces itself with the same event
   (mlb:req-updated) so the page's own list repaints and the tray follows.

   It also draws the saved list on the page grouped by style: one parent row per
   style with its colors as children, to match the tray and the ticket. The list
   is folded into one summary bar until opened, and each style folds its colors.

   The page's own single-color Add handler is left alone for products with one
   color or none, and as the fallback if anything here cannot run. For products
   with several colors this script takes the click first, so one click can never
   add twice. */
(function () {
  "use strict";

  var KEY = "mlbStoreRequest";
  var storageOK = true;
  try { localStorage.setItem("mlbmc_t", "1"); localStorage.removeItem("mlbmc_t"); }
  catch (e) { storageOK = false; }

  var CFG = null, COLORS = [], addBtn = null, panel = null;
  var sel = {};                 /* color name -> true */
  var touched = false;          /* once they use the picker, stop following the main swatch */
  var chips = [], countEl = null, tId;

  function readCfg() {
    var el = document.querySelector('script[id^="mlb-cfg-"]');
    if (!el) return false;
    try { CFG = JSON.parse(el.textContent); } catch (e) { return false; }
    COLORS = (CFG && CFG.colors) || [];
    return true;
  }

  function viewedColor() {
    var b = document.querySelector('.mlb-way[aria-pressed="true"]');
    return b ? b.getAttribute("aria-label") : (COLORS[0] && COLORS[0].n) || "";
  }

  function reqRead() {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]") || []; }
    catch (e) { return []; }
  }

  function css() {
    if (document.getElementById("mlb-mc-css")) return;
    var s = document.createElement("style");
    s.id = "mlb-mc-css";
    s.textContent = [
      ".mlb-mc{margin:0 0 12px}",
      ".mlb-mc-head{display:flex;align-items:baseline;gap:10px;margin-bottom:8px;font:700 13px/1.2 'DM Sans',sans-serif;color:var(--mlb-ink,#12263f)}",
      ".mlb-mc-count{font-weight:500;color:var(--mlb-ink-3,#5d6f82)}",
      ".mlb-mc-links{margin-left:auto;display:flex;gap:12px}",
      ".mlb-mc-links button{border:0;background:none;padding:0;cursor:pointer;font:700 12.5px/1 'DM Sans',sans-serif;color:var(--mlb-teal-deep,#0f8b86)}",
      ".mlb-mc-links button:hover{text-decoration:underline}",
      ".mlb-mc-links button:focus-visible{outline:2px solid var(--mlb-teal-deep,#0f8b86);outline-offset:2px;border-radius:3px}",
      ".mlb-mc-grid{display:flex;flex-wrap:wrap;gap:7px;max-height:176px;overflow:auto;padding:2px}",
      ".mlb-mc-chip{position:relative;display:inline-flex;align-items:center;gap:7px;max-width:100%;cursor:pointer;",
      "padding:6px 11px 6px 7px;border-radius:99px;background:var(--mlb-card,#fff);",
      "border:1px solid var(--mlb-line,#dde3e7);font:600 12.5px/1.1 'DM Sans',sans-serif;color:var(--mlb-ink,#12263f);user-select:none}",
      ".mlb-mc-chip:hover{border-color:var(--mlb-teal,#14bcb4)}",
      ".mlb-mc-chip input{position:absolute;opacity:0;width:1px;height:1px;margin:0;pointer-events:none}",
      ".mlb-mc-chip:focus-within{outline:2px solid var(--mlb-teal-deep,#0f8b86);outline-offset:2px}",
      ".mlb-mc-chip i{flex:none;width:18px;height:18px;border-radius:50%;border:1px solid rgba(18,38,63,.28);display:inline-flex;align-items:center;justify-content:center}",
      ".mlb-mc-chip i svg{width:11px;height:11px;opacity:0;stroke:#fff;filter:drop-shadow(0 0 1px rgba(0,0,0,.75))}",
      ".mlb-mc-chip span{min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}",
      ".mlb-mc-chip.is-on{background:var(--mlb-teal-wash,#e6f7f6);border-color:var(--mlb-teal,#14bcb4);box-shadow:inset 0 0 0 1px var(--mlb-teal,#14bcb4)}",
      ".mlb-mc-chip.is-on i svg{opacity:1}",
      ".mlb-req-add[disabled]{opacity:.5;cursor:not-allowed}",
      ".mlb-sum{display:flex;align-items:center;gap:10px;width:100%;background:var(--mlb-card,#fff);border:1px solid var(--mlb-line,#dde3e7);border-radius:9px;padding:8px 11px;cursor:pointer;text-align:left;font:500 13px/1.3 'DM Sans',sans-serif;color:var(--mlb-ink,#12263f)}",
      ".mlb-sum:hover{border-color:var(--mlb-teal,#14bcb4)}",
      ".mlb-sum:focus-visible{outline:2px solid var(--mlb-teal-deep,#0f8b86);outline-offset:2px}",
      ".mlb-sum-th{display:flex;flex:none}",
      ".mlb-sum-th img{width:28px;height:28px;border-radius:6px;object-fit:cover;background:var(--mlb-page,#f4f6f7);border:2px solid var(--mlb-card,#fff);margin-left:-9px}",
      ".mlb-sum-th img:first-child{margin-left:0}",
      ".mlb-sum-x{flex:1;min-width:0}",
      ".mlb-sum-x b{font-weight:700}",
      ".mlb-sum-v{flex:none;display:inline-flex;align-items:center;gap:7px;font:700 12.5px/1 'DM Sans',sans-serif;color:var(--mlb-teal-deep,#0f8b86)}",
      ".mlb-chev{display:inline-block;width:6px;height:6px;border-right:2px solid currentColor;border-bottom:2px solid currentColor;transform:rotate(45deg);margin-top:-3px;transition:transform .15s}",
      "[aria-expanded=true] .mlb-chev{transform:rotate(-135deg);margin-top:3px}",
      ".mlb-grp{background:var(--mlb-card,#fff);border:1px solid var(--mlb-line,#dde3e7);border-radius:9px;padding:6px 6px 6px 8px}",
      ".mlb-grp-head{display:flex;align-items:center;gap:9px}",
      ".mlb-grp-head img{width:30px;height:30px;border-radius:6px;object-fit:cover;background:var(--mlb-page,#f4f6f7);flex:none}",
      ".mlb-grp-tog{flex:1;min-width:0;display:flex;align-items:center;gap:8px;border:0;background:none;padding:2px 0;cursor:pointer;text-align:left;color:var(--mlb-ink,#12263f)}",
      ".mlb-grp-tog:focus-visible{outline:2px solid var(--mlb-teal-deep,#0f8b86);outline-offset:2px;border-radius:4px}",
      ".mlb-grp-tog[disabled]{cursor:default}",
      ".mlb-grp-w{flex:1;min-width:0;display:block}",
      ".mlb-grp-t,.mlb-grp-s{display:block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}",
      ".mlb-grp-t{font:600 13px/1.3 'DM Sans',sans-serif}",
      ".mlb-grp-s{font:500 12px/1.35 'DM Sans',sans-serif;color:var(--mlb-ink-3,#5d6f82)}",
      ".mlb-grp-tog .mlb-chev{color:var(--mlb-ink-3,#5d6f82);flex:none;margin-right:4px}",
      ".mlb-grp-cols{display:flex;flex-wrap:wrap;gap:5px;margin:7px 0 2px 39px}",
      ".mlb-grp-col{display:inline-flex;align-items:center;gap:2px;background:var(--mlb-page,#f4f6f7);border-radius:99px;padding:3px 3px 3px 10px;font:600 12px/1.2 'DM Sans',sans-serif;color:var(--mlb-ink,#12263f)}",
      ".mlb-grp-col .mlb-req-x{padding:2px 6px;font-size:13px}"
    ].join("\n");
    document.head.appendChild(s);
  }

  function selectedList() {
    return COLORS.filter(function (c) { return sel[c.n]; });
  }

  function paint() {
    chips.forEach(function (o) {
      var on = !!sel[o.name];
      o.input.checked = on;
      o.label.classList.toggle("is-on", on);
    });
    var n = selectedList().length;
    if (countEl) countEl.textContent = n + " of " + COLORS.length + " selected";
    if (addBtn) {
      var tn = null;
      for (var i = addBtn.childNodes.length - 1; i >= 0; i--) {
        if (addBtn.childNodes[i].nodeType === 3 && addBtn.childNodes[i].textContent.trim()) { tn = addBtn.childNodes[i]; break; }
      }
      var txt = n === 0 ? "Choose at least one color"
        : n === 1 ? "Add this style to my request"
        : "Add " + n + " colors to my request";
      if (tn) tn.textContent = "\n              " + txt + "\n            ";
      addBtn.disabled = n === 0;
    }
  }

  function followViewed() {
    if (touched) return;
    sel = {};
    var v = viewedColor();
    if (v) sel[v] = true;
    paint();
  }

  function build() {
    panel = document.createElement("div");
    panel.className = "mlb-mc";
    panel.setAttribute("data-mc", "");

    var head = document.createElement("div");
    head.className = "mlb-mc-head";
    var t = document.createElement("span");
    t.textContent = "Colors";
    countEl = document.createElement("span");
    countEl.className = "mlb-mc-count";
    var links = document.createElement("span");
    links.className = "mlb-mc-links";
    var all = document.createElement("button");
    all.type = "button"; all.textContent = "Select all";
    var none = document.createElement("button");
    none.type = "button"; none.textContent = "Clear";
    links.appendChild(all); links.appendChild(none);
    head.appendChild(t); head.appendChild(countEl); head.appendChild(links);

    var grid = document.createElement("div");
    grid.className = "mlb-mc-grid";
    grid.setAttribute("role", "group");
    grid.setAttribute("aria-label", "Colors to add to your request");

    COLORS.forEach(function (c) {
      var label = document.createElement("label");
      label.className = "mlb-mc-chip";
      var input = document.createElement("input");
      input.type = "checkbox";
      input.value = c.n;
      var dot = document.createElement("i");
      if (c.h) dot.style.background = c.h;
      dot.innerHTML = '<svg viewBox="0 0 12 12" fill="none" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.4l2.3 2.3 4.7-5"/></svg>';
      var name = document.createElement("span");
      name.textContent = c.n;
      label.appendChild(input); label.appendChild(dot); label.appendChild(name);
      input.addEventListener("change", function () {
        touched = true;
        if (input.checked) sel[c.n] = true; else delete sel[c.n];
        paint();
      });
      grid.appendChild(label);
      chips.push({ name: c.n, input: input, label: label });
    });

    all.addEventListener("click", function () {
      touched = true; sel = {};
      COLORS.forEach(function (c) { sel[c.n] = true; });
      paint();
    });
    none.addEventListener("click", function () {
      touched = true; sel = {};
      paint();
    });

    panel.appendChild(head); panel.appendChild(grid);
    addBtn.parentNode.insertBefore(panel, addBtn);
  }

  function toast(msg) {
    var t = document.querySelector("[data-toast]");
    if (!t) return;
    t.textContent = msg; t.classList.add("up");
    clearTimeout(tId);
    tId = setTimeout(function () { t.classList.remove("up"); }, 3600);
  }

  /* a small image for the list, from the colorway's own photo when it has one */
  function thumbFor(c) {
    var u = c && c.img ? String(c.img) : "";
    if (u) return u.replace(/([?&])width=\d+/, "$1width=120");
    return CFG.thumb || "";
  }

  function addSelected() {
    var picked = selectedList();
    if (!picked.length) return;
    var list = reqRead();
    var spotList = CFG.blank ? [] : (CFG.spots || []).map(function (s) { return { n: s.name, m: s.max || "" }; }).filter(function (s) { return s.n; });
    var added = 0, had = 0;
    picked.forEach(function (c) {
      var dup = list.some(function (o) { return o.h === CFG.handle && o.color === (c.n || ""); });
      if (dup) { had++; return; }
      list.push({
        h: CFG.handle, title: CFG.title || CFG.handle, color: c.n || "",
        img: thumbFor(c), blank: !!CFG.blank,
        method: CFG.blank ? "" : (CFG.method || ""),
        spots: spotList.map(function (s) { return { n: s.n, m: s.m }; }),
        loc: spotList[0] ? spotList[0].n : "", det: 1
      });
      added++;
    });
    if (added) {
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
      document.dispatchEvent(new CustomEvent("mlb:req-updated"));
    }
    if (!added) toast(picked.length > 1 ? "Those colors are already on your request." : "Already on your request.");
    else if (had) toast("Added " + added + (added === 1 ? " color" : " colors") + ", " + had + " already on your request.");
    else if (added === 1) toast("Added. Keep browsing, or send the request when your list is ready.");
    else toast("Added " + added + " colors. Keep browsing, or send the request when your list is ready.");
  }

  /* ---------- the saved list, parent style then its colors ---------- */
  var painting = false, listObs = null;
  /* Collapsed by default, because the list grows fast with several colors per
     style. One bar sums it up; opening it shows one line per style, and a
     style opens to its colors only when someone wants to change them. */
  var TIMES = String.fromCharCode(215);
  var listOpen = false, openGrp = {};
  function colorLine(g) {
    if (!g.colors.length) return "";
    if (g.colors.length === 1) return g.colors[0];
    return g.colors.length + " colors: " + g.colors.join(", ");
  }
  function chev() { var i = document.createElement("i"); i.className = "mlb-chev"; i.setAttribute("aria-hidden", "true"); return i; }

  function groupRow(g) {
    var row = document.createElement("div");
    row.className = "mlb-grp";
    var head = document.createElement("div");
    head.className = "mlb-grp-head";
    var img = document.createElement("img");
    img.src = g.img || ""; img.alt = ""; img.width = 30; img.height = 30;
    var many = g.colors.length > 1;
    var tog = document.createElement("button");
    tog.type = "button"; tog.className = "mlb-grp-tog";
    var w = document.createElement("span"); w.className = "mlb-grp-w";
    var t = document.createElement("span"); t.className = "mlb-grp-t"; t.textContent = g.title;
    w.appendChild(t);
    var line = colorLine(g);
    if (line) { var sub = document.createElement("span"); sub.className = "mlb-grp-s"; sub.textContent = line; w.appendChild(sub); }
    tog.appendChild(w);
    if (many) {
      tog.setAttribute("aria-expanded", String(!!openGrp[g.h]));
      tog.setAttribute("aria-label", g.title + ", " + line + ". " + (openGrp[g.h] ? "Hide colors" : "Show colors to change them"));
      tog.appendChild(chev());
      tog.addEventListener("click", function () { openGrp[g.h] = !openGrp[g.h]; paintPanel(); });
    } else {
      tog.disabled = true;
    }
    var x = document.createElement("button");
    x.type = "button"; x.className = "mlb-req-x";
    x.setAttribute("aria-label", "Remove " + g.title + (many ? " and all its colors" : ""));
    x.textContent = TIMES;
    x.addEventListener("click", function () { removeWhere(function (o) { return o.h === g.h; }); });
    head.appendChild(img); head.appendChild(tog); head.appendChild(x);
    row.appendChild(head);
    if (many && openGrp[g.h]) {
      var cols = document.createElement("div");
      cols.className = "mlb-grp-cols";
      g.colors.forEach(function (c) {
        var chip = document.createElement("span");
        chip.className = "mlb-grp-col";
        chip.appendChild(document.createTextNode(c));
        var cx = document.createElement("button");
        cx.type = "button"; cx.className = "mlb-req-x";
        cx.setAttribute("aria-label", "Remove " + c);
        cx.textContent = TIMES;
        cx.addEventListener("click", function () { removeWhere(function (o) { return o.h === g.h && o.color === c; }); });
        chip.appendChild(cx);
        cols.appendChild(chip);
      });
      row.appendChild(cols);
    }
    return row;
  }

  function paintPanel() {
    if (painting) return;
    /* the header count always; the list only if the page still carries one */
    var listEl = document.querySelector("[data-req-list]");
    painting = true;
    var list = reqRead(), order = [], by = {};
    list.forEach(function (o) {
      if (!o || !o.h) return;
      if (!by[o.h]) { by[o.h] = { h: o.h, title: o.title, img: o.img, colors: [] }; order.push(by[o.h]); }
      if (o.color && by[o.h].colors.indexOf(o.color) === -1) by[o.h].colors.push(o.color);
    });
    var wrap = document.querySelector("[data-req]");
    if (wrap) wrap.hidden = list.length === 0;
    var nCol = 0;
    order.forEach(function (g) { nCol += Math.max(1, g.colors.length); });
    var count = document.querySelector("[data-req-count]");
    if (count) {
      count.textContent = order.length
        ? order.length + (order.length === 1 ? " style" : " styles") + (nCol > order.length ? ", " + nCol + " colors" : "")
        : "";
    }
    if (!listEl) { painting = false; return; }
    listEl.textContent = "";
    if (order.length) {
      var bar = document.createElement("button");
      bar.type = "button"; bar.className = "mlb-sum";
      bar.setAttribute("aria-expanded", String(listOpen));
      var th = document.createElement("span"); th.className = "mlb-sum-th";
      order.slice(0, 3).forEach(function (g) {
        var im = document.createElement("img"); im.src = g.img || ""; im.alt = ""; im.width = 28; im.height = 28; th.appendChild(im);
      });
      var tx = document.createElement("span"); tx.className = "mlb-sum-x";
      var b = document.createElement("b");
      b.textContent = order.length + (order.length === 1 ? " style" : " styles");
      tx.appendChild(b);
      tx.appendChild(document.createTextNode((nCol > order.length ? ", " + nCol + " colors" : "") + " on your request"));
      var v = document.createElement("span"); v.className = "mlb-sum-v";
      v.appendChild(document.createTextNode(listOpen ? "Hide" : "View"));
      v.appendChild(chev());
      bar.appendChild(th); bar.appendChild(tx); bar.appendChild(v);
      bar.addEventListener("click", function () { listOpen = !listOpen; paintPanel(); });
      listEl.appendChild(bar);
      if (listOpen) order.forEach(function (g) { listEl.appendChild(groupRow(g)); });
    }
    painting = false;
  }

  function removeWhere(test) {
    var next = reqRead().filter(function (o) { return !test(o); });
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) {}
    document.dispatchEvent(new CustomEvent("mlb:req-updated"));
  }

  var panelReady = false;
  function initPanel() {
    if (panelReady || !storageOK) return;
    var listEl = document.querySelector("[data-req-list]");
    if (!listEl && !document.querySelector("[data-req-count]")) return;
    panelReady = true;
    css();
    paintPanel();
    /* the page repaints the flat list on this event and on boot; this listener
       was added later, so it runs last and has the final word */
    document.addEventListener("mlb:req-updated", paintPanel);
    window.addEventListener("storage", function (ev) { if (!ev.key || ev.key === KEY) paintPanel(); });
    /* and if the page's own script draws its flat list after we did, redraw */
    if (listEl && window.MutationObserver) {
      listObs = new MutationObserver(function () {
        if (painting) return;
        var first = listEl.firstElementChild;
        if (first && !first.classList.contains("mlb-sum")) paintPanel();
      });
      listObs.observe(listEl, { childList: true });
    }
  }

  function init() {
    if (!readCfg() || !storageOK) return true;
    initPanel();
    if (COLORS.length < 2) return true;
    addBtn = document.querySelector("[data-req-add]");
    if (!addBtn) return true;
    /* the page builds its swatches in its own script, wait for them */
    if (document.querySelectorAll(".mlb-way").length < COLORS.length) return false;

    css();
    build();
    followViewed();

    /* capture phase on the document, so this runs before the page's own
       single-color handler, which then never sees the click */
    document.addEventListener("click", function (ev) {
      var b = ev.target && ev.target.closest ? ev.target.closest("[data-req-add]") : null;
      if (!b) return;
      ev.preventDefault();
      ev.stopImmediatePropagation();
      if (b.disabled) return;
      addSelected();
    }, true);

    /* the main swatches decide what is selected until the visitor uses the picker */
    var ways = document.querySelector("[data-ways]");
    if (ways && window.MutationObserver) {
      new MutationObserver(followViewed).observe(ways, { attributes: true, subtree: true, attributeFilter: ["aria-pressed"] });
    }
    return true;
  }

  var tries = 0;
  function start() {
    if (init()) return;
    if (++tries < 60) setTimeout(start, 100);
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
